import { useContext } from 'react';
import { RouteHistoryContext } from './context';
import { DefaultRouteHistoryValuesContextProps } from './route-history-types';

export const useRouteHistoryContext = (): DefaultRouteHistoryValuesContextProps => {
  const context = useContext(RouteHistoryContext);
  if (!context) {
    throw new Error('usePathHistory must be used within a PathHistoryProvider');
  }
  return context;
};